import React from "react";
import { content } from "../data/content";

const LanguageContext = React.createContext({ lang: "en", setLang: () => {}, t: content.en });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = React.useState(() => {
    try {
      const stored = localStorage.getItem("ors_lang");
      if (stored === "en" || stored === "de") return stored;
    } catch (_) {}
    return "en";
  });

  const setLang = React.useCallback((next) => {
    setLangState(next);
    try {
      localStorage.setItem("ors_lang", next);
    } catch (_) {}
    if (typeof document !== "undefined") document.documentElement.lang = next;
  }, []);

  React.useEffect(() => {
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  const t = content[lang] || content.en;
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>
  );
};

export const useT = () => React.useContext(LanguageContext);
